// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"_Y-z"};